import { useState } from "react"

import { Checkbox, Flex, Modal, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import ButtonComponent from "../../../../../Components/Button"
import Icon from "../../../../../Icon"
import Images from "../../../../../Images"
import { generateInviteEmail } from "../../CreditsAutomationConnectGuide/utils/generateInviteEmail"

import styles from "../AutomateCreditsModal/AutomateCreditsModal.module.less"

const { Title, Text } = Typography

export const ShopifyActivateAccessModal = ({
  open,
  onCancel,
  onActivate,
  acceptUrl,
  activateFetching = false
}) => {
  const { t } = useTranslation()
  const isMobile = useSelector((state) => state.nav.isMobile)
  const businessAccount = useSelector((state) => state.user.businessAccount)
  const [confirmed, setConfirmed] = useState(false)

  // The generated collaborator identity (CHA1-3211); falls back to the task's literal address.
  const email = generateInviteEmail({ businessAccount, pp: "shopify" }) || "team@chargeback.io"

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      centered={!isMobile}
      width={442}
      title={null}
      footer={null}
      destroyOnClose
      classNames={{ content: "clear-bg" }}
      closeIcon={<Icon type="cross_small" />}
      getContainer={() => document.getElementById("main-layout")}
    >
      <Flex vertical gap={16} className={styles.singleWrapper}>
        <div className={styles.singleIconCombo}>
          <img src={Images.integration_shopify} width={20} height={20} alt="Shopify" />
          <div className={styles.icon}>
            <Icon type="automation_loop_blue" />
          </div>
        </div>

        <Title level={5} style={{ margin: 0 }}>
          {t("Automate credits")}
        </Title>

        <Text type="secondary">
          {t(
            "Follow these steps to securely connect your Shopify account with Chargeback and automate credit requests."
          )}
        </Text>

        <Flex vertical gap={16}>
          <Text type="secondary">
            {t(
              "1. Accept the Shopify collaborator request within 5 min. After it expires, a new access request will be required."
            )}
          </Text>
          <Text type="secondary">
            {t(
              "2. Do not change the requested permissions, otherwise Credit Automation may not work correctly."
            )}
          </Text>
        </Flex>

        <ButtonComponent
          block
          disabled={!acceptUrl}
          onClick={() => acceptUrl && window.open(acceptUrl, "_blank", "noopener,noreferrer")}
        >
          <Flex align="center" justify="center" gap={8}>
            <img src={Images.integration_shopify} width={16} height={16} alt="" />
            {t("Go to Shopify")}
            <Icon type="arrow_out_of_box" />
          </Flex>
        </ButtonComponent>

        <Checkbox checked={confirmed} onChange={(e) => setConfirmed(e.target.checked)}>
          {t("I've accepted the collaborator request from _email_ with the required access.", {
            email
          })}
        </Checkbox>

        <Flex justify="end" gap={8} className={styles.footer}>
          <ButtonComponent onClick={onCancel}>{t("Cancel")}</ButtonComponent>
          <ButtonComponent
            type="primary"
            disabled={!confirmed}
            loading={activateFetching}
            onClick={onActivate}
          >
            {t("Activate")}
          </ButtonComponent>
        </Flex>
      </Flex>
    </Modal>
  )
}

export default ShopifyActivateAccessModal
